<!--start section header-->
 
<header class="head">
    <div class="cover">
        <div class="container d-flex justify-content-center align-items-center pt-5">
         <div>
             <h2 class="pt-5">
                Product
             </h2>
             <nav aria-label="breadcrumb">
                 <ol class="breadcrumb">
                   <li (click) = change() class="breadcrumb-item">
                       <a>Home</a>
                     </li>
                   <li class="breadcrumb-item active" aria-current="page">Product</li>
                 </ol>
             </nav>
         </div>
 
        </div>
    </div>
 
 </header>
 
 <!--end section header-->


 <!--start section Product-->

<section class="py-5 container product">
    <div class="row pt-5 pb-4">


        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/a.png" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Tongue Pastrami Salami
                      <p> <span class="pr-2">$12.00</span> $10.00</p>
                  </h5>
                  <p class="card-text">Shankle ball tip bresaola kielbasa short <br>
                     loin, tongue swine sausage hamburger <br>
                      meatball pork.
                  </p>
                  <button class="btn btn-outline-primary">Add to Cart</button>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/d.png" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Ground Round Turkey
                    <p> <span class="pr-2">$12.00</span> $10.00</p>
                  </h5>
                  <p class="card-text">Drumstick biltong shoulder spare ribs. T- <br>
                     bone shankle corned beef flank swine <br>
                      meatball jowl.
                  </p>
                  <button class="btn btn-outline-primary">Add to Cart</button>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/g.png" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Kevin Shoulder
                    <p> <span class="pr-2">$12.00</span> $10.00</p>
                  </h5>
                  <p class="card-text">Shank rump ham, pastrami strip steak <br>
                     capicola brisket chuck leberkas. Jerky <br>
                      jowl landjaeger.
                  </p>
                  <button class="btn btn-outline-primary">Add to Cart</button>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/l.png" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Cupim Salami Sirloin
                    <p> <span class="pr-2">$12.00</span> $10.00</p>
                  </h5>
                  <p class="card-text">Frankfurter pig bacon bresaola brisket. <br>
                     Alcatra burgdoggen pork chop, bacon <br>
                      sausage.
                  </p>
                  <button class="btn btn-outline-primary">Add to Cart</button>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/b.png" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Shank Cow Boudin
                    <p> <span class="pr-2">$12.00</span> $10.00</p>
                  </h5>
                  <p class="card-text">Ham hock landjaeger prosciutto cow <br>
                     bacon salami, doner leberkas andouille <br>
                      bresaola.
                 </p>
                  <button class="btn btn-outline-primary">Add to Cart</button>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/q.png" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Prosciutto Picanha Pork
                    <p> <span class="pr-2">$12.00</span> $10.00</p>
                  </h5>
                  <p class="card-text">Pancetta chuck jowl shank cow sausage <br>
                     flank tongue filet mignon kevin. Ground <br>
                      round ball.
                  </p>
                  <button class="btn btn-outline-primary">Add to Cart</button>
                </div>
              </div>
        </div>

    </div>
    <div class="row d-flex justify-content-center product-footer">
        <nav aria-label="Page navigation example">
            <ul class="pagination pagination-lg">
              <li class="page-item"><a class="page-link" href="#"><<</a></li>
              <li class="page-item"><a class="page-link" href="#">1</a></li>
              <li class="page-item"><a class="page-link page-link-one" href="#">2</a></li>
              <li class="page-item"><a class="page-link" href="#">3</a></li>
              <li class="page-item"><a class="page-link" href="#">>></a></li>
            </ul>
          </nav>
    </div>

</section>

<!--end section Product-->